import { AppRoutes } from './routes';
import { useBrandFavicon } from './services/httpServices/queries';

function App() {
  useBrandFavicon();
  return <AppRoutes />;
}

export default App;